import React from "react";
import "../styles/playerStats.css";
import Typewritter from "../typeeffect/Typewritter";

const PlayerStats = () => {
  return (
    <div id="playerStats">
      <h1 style={{ color: "#FF5733" }}>AMJAD HOSSAIN</h1>
      <div id="playerStats__lines">
        <span id="playerStats__lines__thick"></span>
        <span id="playerStats__lines__thin"></span>
      </div>
      <Typewritter />
    </div>
  );
};

export default PlayerStats;
